import { Box } from "@mui/material";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

/**
 * =========================================================
 * ✅ SORTABLE ROOM (FINAL)
 * =========================================================
 */
export default function SortableRoom({ room, children, disabled }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: room.id,
    disabled,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.6 : 1,
  };

  return (
    <Box ref={setNodeRef} style={style}>
      {typeof children === "function"
        ? children({
            listeners: disabled ? {} : listeners,
            attributes: disabled ? {} : attributes,
          })
        : children}
    </Box>
  );
}
